export function timesheetRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_TIMESHEET_START":           
        case "FETCH_TIMESHEETS_START":                                 
        case "UPDATE_TIMESHEET_START":                                 
        case "DELETE_TIMESHEET_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_TIMESHEET_FULFILLED":           
        case "FETCH_TIMESHEETS_FULFILLED":                                 
        case "UPDATE_TIMESHEET_FULFILLED":                                 
        case "DELETE_TIMESHEET_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_TIMESHEET_ERROR":
        case "FETCH_TIMESHEETS_ERROR":
        case "UPDATE_TIMESHEET_ERROR":
        case "DELETE_TIMESHEET_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}